import { useEffect } from "react";

export default function GoogleMapsStyleGuard() {
  useEffect(() => {
    const disableInjectedStyles = () => {
      document.querySelectorAll("style").forEach((styleEl) => {
        const el = styleEl as HTMLStyleElement & { _gmDisabled?: boolean };
        if (el._gmDisabled) return;
        const content = el.textContent || "";
        if (content.includes("gm-style") && content.includes("Roboto")) {
          el.disabled = true;
          el._gmDisabled = true;
        }
      });
    };

    disableInjectedStyles();
    const observer = new MutationObserver(disableInjectedStyles);
    observer.observe(document.head, { childList: true });
    return () => observer.disconnect();
  }, []);

  return null;
}
